module.exports = __webpack_public_path__ + "img/chat-user2.bab4e43d.png";